import React from 'react';

import style from './style.module.scss';

export default ({ className = null }) => {
  return (
    <div className={[style.loading, className].join(' ')}>Loading&#8230;</div>
  );
};
